import { render, staticRenderFns } from "./AdminConsole.vue?vue&type=template&id=4e89ca6b&"
import script from "./AdminConsole.vue?vue&type=script&lang=js&"
export * from "./AdminConsole.vue?vue&type=script&lang=js&"
import style0 from "./AdminConsole.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports